import { MetaPagination } from "constants/common.constants";
import { Obj } from "./types";

export interface SelectOption {
  label: string;
  value: string;
}

export interface NavigateType {
  onCategory: (value: string) => void;
}

export interface Pagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface SelectOption {
  value: string;
  label: string;
}

export enum FundType {
  MinimumFund = "minimum_fund",
  OnDemand = "on_demand",
  None = "none",
}

export enum FormatDateType {
  DDMMYYYY = "DD/MM/YYYY",
  MMDDYYYY = "MM/DD/YYYY",
  YYYYMMDD = "YYYY/MM/DD",
  DDMMYYYYHHMM = "DD/MM/YYYY HH:MM",
  MMDDYYYYHHMM = "MM/DD/YYYY HH:MM",
  MMMDDYYYYHHMMSS = "MMM DD, YYYY HH:MM:SS",
  YYYYMMDDHHMM = "YYYY/MM/DD HH:MM",
  MMMDDYYYY = "MMM DD, YYYY",
  MMMDDYYYYHHMMAMPM = "MMM DD, YYYY · HH:MM AM/PM",
}

export const RuleActions = {
  BLOCK: "block",
} as const;

export enum FormatDateApi {
  YYYYMMDD = "YYYY-MM-DD",
}

export type DataResponse<T> = {
  data?: T;
  meta?: MetaPagination;
  errors?: Obj;
  success?: boolean;
  friendly_message?: string,
  message?: string;
  status?: number;
};

export type TitleDescription = {
  title?: string;
  description?: string;
};
